import React from 'react';
import BaseWalletPage from './BaseWalletPage';

function WalletPage() {
    return <BaseWalletPage shouldListenForResize />;
}

WalletPage.displayName = 'WalletPage';

export default WalletPage;
